"use strict";
exports.__esModule = true;
var react_1 = require("react");
var useMounted = function () {
    var _a = (0, react_1.useState)(false), isMounted = _a[0], setIsMounted = _a[1];
    (0, react_1.useEffect)(function () {
        setIsMounted(true);
    }, []);
    return isMounted;
};
exports["default"] = useMounted;
